<template>
  <el-button type="primary" icon="el-icon-search" size="mini" @click="childclick">
    <slot>查询</slot>
  </el-button>
</template>

<script>

export default {
  components: {},
  props: {},
  data() {
    return {
      keyCode:''
    };
  },
  created() {},
  mounted() {
    document.onkeydown = this.test;
  },
  methods: {
    childclick() {
      this.$emit('click');
    },
    test(event){
      var e = event || window.event ;
      if (e && e.keyCode == 27) {
        // 按 Esc
      }
      if (e && e.keyCode == 113) {
        // 按 F2
      }
      if (e && e.keyCode == 13) {
       this.childclick();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>